import { TableHeader } from '@react-stately/table';
import {
  DisableKeyboardNav,
  InteractiveTable,
  InteractiveTableBody,
  type InteractiveTableBodyProps,
  InteractiveTableCell,
  type InteractiveTableCellProps,
  InteractiveTableColumn,
  type InteractiveTableColumnProps,
  InteractiveTableFooter,
  InteractiveTableHeader,
  type InteractiveTableProps,
  InteractiveTableRow,
  type InteractiveTableRowProps,
} from './src/InteractiveTable';
import { EditableCell, type EditableCellProps } from './src/EditableCell';
// Not using export { SortDescriptor } from '@react-types/shared'
// as it causes some issues when building storybook
import { SortDescriptor as SharedSortDescriptor } from '@react-types/shared';
import { WithoutInternals } from '../utils';

const _InteractiveTable = Object.assign(InteractiveTable, {
  Body: InteractiveTableBody,
  Column: InteractiveTableColumn,
  Row: InteractiveTableRow,
  Cell: InteractiveTableCell as WithoutInternals<typeof InteractiveTableCell>,
  EditableCell,
  Header: InteractiveTableHeader,
  Footer: InteractiveTableFooter,
  DisableKeyboardNav,
});

export { _InteractiveTable as InteractiveTable };
export { TableHeader };

export type {
  InteractiveTableProps,
  InteractiveTableBodyProps,
  InteractiveTableColumnProps,
  InteractiveTableCellProps,
  InteractiveTableRowProps,
  EditableCellProps,
};

export type SortDescriptor = SharedSortDescriptor;
export type { CellOverflow } from '../Table';
